<template>
    <div class=" mr-10 mt-6 w-1/3 md:w-full">

<div>
            <div class="flex"> 
                <div v-if="rider.passport && rider.passport.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                    <p class="text-xs">Passport</p>
                    <a :href="rider.passport" target="_blank"><img class="w-full h-32 " src="../assets/pdf.png" alt="Passport"></a>
                </div>
                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                    <p class="text-xs">Passport</p>
                    <a :href="rider.passport" target="_blank"><img class="w-full h-32 " :src="rider.passport" alt="Passport"></a>
                </div>

                <div v-if="rider.idCard && rider.idCard.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                    <p class="text-xs">ID Card</p>
                    <a :href="rider.idCard" target="_blank"><img src="../assets/pdf.png" class="w-full h-32" alt="ID Card"></a>
                </div>
                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                    <p class="text-xs">ID Card</p>
                    <a :href="rider.idCard" target="_blank"><img :src="rider.idCard" class="w-full h-32" alt="ID Card"></a>
                </div>
                
            </div>

            <div class="flex mt-8">
                
                <div v-if="rider.originCertificate && rider.originCertificate.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                    <p class="text-xs">Origin Certificate</p>
                    <a target="_blank" :href="rider.originCertificate"><img class="w-full h-32 " src="../assets/pdf.png" alt="Origin-Certificate"></a>
                </div>
                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                    <p class="text-xs">Origin Certificate</p>
                    <a target="_blank" :href="rider.originCertificate"><img class="w-full h-32 " :src="rider.originCertificate" alt="Origin-Certificate"></a>
                </div>
                <div v-if="rider.lasra && rider.lasra.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                    <p class="text-xs">Lasra</p>
                    <a target="_blank" :href="rider.lasra"><img class="w-full h-32 " src="../assets/pdf.png" alt="lasra"></a>
                </div>
                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border ">
                    <p class="text-xs">Lasra</p>
                    <a target="_blank" :href="rider.lasra"><img class="w-full h-32 " :src="rider.lasra" alt="lasra"></a>
                </div>
                
            </div>

            <div class="flex mt-8">
                
                <div v-if="rider.vehicleReceipt && rider.vehicleReceipt.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                    <p class="text-xs">Vehicle Receipt</p>
                    <a target="_blank" :href="rider.vehicleReceipt"><img class="w-full h-32 " src="../assets/pdf.png" alt="vehicle Receipt"></a>
                </div>
                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                    <p class="text-xs">Vehicle Receipt</p>
                    <a target="_blank" :href="rider.vehicleReceipt"><img class="w-full h-32 " :src="rider.vehicleReceipt" alt="vehicle Receipt"></a>
                </div>
                <div v-if="rider.roadWorthiness && rider.roadWorthiness.includes('pdf')" class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                    <p class="text-xs">Road Worthiness</p>
                    <a target="_blank" :href="rider.roadWorthiness"><img class="w-full h-32 " src="../assets/pdf.png" alt="Road Worthiness"></a>
                </div>
                <div v-else class="ml-8 w-1/3 h-32 rounded-xl bg-gray-200 border">
                    <p class="text-xs">Road Worthiness</p>
                    <a target="_blank" :href="rider.roadWorthiness"><img class="w-full h-32 " :src="rider.roadWorthiness" alt="Road Worthiness"></a>
                </div>
                
            </div>
        </div>  
                
    </div>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    props: ["id"],
    data() {
        return {
            rider : [],
            email : this.$store.state.riderEmail
        }
    },

    mounted() {
        this.getRider()
    },

    methods: {
        getRider() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/riders/check/${this.email}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response)=> {
                this.rider = response.data.data
            })
            .catch((error) => {
                error;
            })
        },
    }
}
</script>